import React from "react";
import { DRAFT_EVENT } from "../../../../constants";
import { Images } from "../../../../assets/images";

const DraftEvent = (props) => {
  const { handleDraft, selectedFormEvent } = props;

  return (
    <div className="col-12 mt-4">
      <div className="draft-event-shutterB text-center py-5 px-3">
        <p className="label-content clr-black">Looks like our hive’s a little busy for your event.</p>
        <p className="text-content mt-1">
          We couldn’t match a shutterb for your event — but don’t worry, our team will get buzzing to find one for you.
          <br />
          Click “find me a shutterb” and we’ll start searching right away.
          <br />
          You’ll only be billed if we confirm a match, and if you don’t hear back, it just means we couldn’t find an available shutterb this time around.
        </p>
        <div className="">
          <button
            className="button-common button-fill"
            onClick={() => handleDraft(DRAFT_EVENT.DRAFT)}
            disabled={selectedFormEvent?.isSaveAsDraft}
          >
            find me a shutterb
          </button>
        </div>

        {selectedFormEvent && selectedFormEvent.isSaveAsDraft && (
          <div className=" d-flex justify-content-center align-items-end">
            <img
              className="draft-event-selected-img"
              src={Images.TickMark}
              alt=""
            />
            <p className="label-content mt-4 teal-color mb-0 ml-1">
              Event is selected as draft
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DraftEvent;
